// Chakra imports
import {
	Button,
	Icon,
	Badge,
	Box,
	Flex,
	Text,
	useColorModeValue,
	useToast,
	Spinner,
	SimpleGrid,
	Card,
	CardHeader,
	CardBody,
	Heading,
	Stack,
	Stat,
	StatLabel,
	StatNumber,
	HStack,
	AlertDialog,
	AlertDialogBody,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogContent,
	AlertDialogOverlay,
	useDisclosure,
	Center,
	Switch,
	FormControl,
	FormLabel,  // Quita la coma aquí
	VStack,     // Agrega esta línea
	Input,       // Agrega esta línea
	Textarea,
	Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Image,
  Wrap,
  WrapItem,
  Progress,

	// useColorMode
} from '@chakra-ui/react';

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { MdArrowBack, MdAttachMoney, MdCalendarToday, MdBusiness, MdLocationOn, MdPerson, MdComputer, MdCategory, MdSecurity, MdHotel, MdEdit, MdSave, MdCancel, MdExitToApp, MdDescription, MdCarRental, MdCheckCircle, MdQrCode2 } from 'react-icons/md';
import activosApi from 'api/activos';
import hotelesApi from 'api/hoteles';
import departamentosApi from 'api/departamentos';
import proveedoresApi from 'api/proveedores';
import modelosApi from 'api/modelos';
import familiasApi from 'api/familias';
import estadosApi from 'api/estados';
import imagenesApi from 'api/imagenes';
import qrsApi from 'api/qrs';
import facturasApi from 'api/facturas';
import tipoAdquisicionApi from 'api/tipoAdquisicion';
import arrendadorasApi from 'api/arrendadoras';
import InputField from 'components/fields/InputField';
import PickList from 'components/fields/PickList';
import SelectField from 'components/fields/SelectField';
import historialApi from 'api/historialEstados';
import { isSoloLectura, getDepartamentosPermitidos } from 'utils/permissions';

const ProductPage = () => {
	const { id } = useParams<{ id: string }>();
	const navigate = useNavigate();
	const userId = JSON.parse(sessionStorage.getItem('user') || '{}');
	const [searchParams] = useSearchParams();
	const mode = isSoloLectura() ? 'view' : (searchParams.get('mode') || 'view');
	const [activo, setActivo] = useState<any>(null);
	const [loading, setLoading] = useState(true);
	const [isEditing, setIsEditing] = useState(mode === 'edit');
	const [editedActivo, setEditedActivo] = useState<any>(null);
	const [hasChanges, setHasChanges] = useState(false);
	const [hoteles, setHoteles] = useState<any[]>([]);
	const [departamentos, setDepartamentos] = useState<any[]>([]);
	const [proveedores, setProveedores] = useState<any[]>([]);
	const [modelos, setModelos] = useState<any[]>([]);
	const [qr, setQR] = useState<any[]>([]);
	const [sublineas, setSublineas] = useState<any[]>([]);
	const [subfamilias, setSubfamilias] = useState<any[]>([]);
	const [estados, setEstados] = useState<any[]>([]);
	const [imagenes, setImagenes] = useState<any[]>([]);
	const [facturas, setFacturas] = useState<any[]>([]);
	const [tiposAdquisicion, setTiposAdquisicion] = useState<any[]>([]);
	const [arrendadoras, setArrendadoras] = useState<any[]>([]);
	const [isCreatingArrendadora, setIsCreatingArrendadora] = useState(false);
	const toast = useToast();
	const { isOpen, onOpen, onClose } = useDisclosure();
	const [historial, setHistorial] = useState<any[]>([]);

	// Agregar este estado cerca de los demás estados
	const [userHotels, setUserHotels] = useState<string[]>([]);
	const [hasPermission, setHasPermission] = useState<boolean>(true);

	const [isEditingImage, setIsEditingImage] = useState(false);
	const [selectedImage, setSelectedImage] = useState<File | null>(null);
	const [imagePreview, setImagePreview] = useState<string | null>(null);

	const cancelRef = useRef();
	// const { colorMode } = useColorMode();
	// const grayColor = useColorModeValue('gray.500', 'whiteAlpha.600');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = useColorModeValue('secondaryGray.600', 'whiteAlpha.600');
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');
	// const bgColor = useColorModeValue('white', 'navy.800');
	const cardBg = useColorModeValue('white', 'navy.700');
	const sectionBg = useColorModeValue('gray.50', 'navy.700');
	const progressTrackBg = useColorModeValue('gray.100', 'whiteAlpha.200');
	// Cerca de los otros useDisclosure
const { isOpen: isImageModalOpen, onOpen: onOpenImageModal, onClose: onCloseImageModal } = useDisclosure();
	// Función para convertir array de bytes ASCII a string
	const bufferToString = (bufferData: number[]) => {
		return String.fromCharCode(...bufferData);
	};

	// Definir tipo para el mapeo de hoteles
	type HotelMappings = {
		[key: string]: string;
	};

	// Mapa de códigos de hotel a nombres completos
	const hotelMappings: HotelMappings = {
		'GVRN': 'Grand Velas Riviera Nayarit',
		'GVRM': 'Grand Velas Riviera Maya',
		'GVBLC': 'Grand Velas Boutique Los Cabos',
		'GVLC': 'Grand Velas Los Cabos',
		'VV': 'Velas Vallarta',
		'CV': 'Casa Velas',
		'MDC': 'Mar del Cabo',
		'CC': 'Contact Center',
		'DEMO': 'Hotel Demo'
	};
	// En la función handleSwitchChange:

	const handleSwitchChange = (id: string, value: any) => {
		setEditedActivo((prev: any) => {
			const newValue = {
				...prev,
				[id]: value
			};

			const hasChanges = Object.keys(newValue).some(key =>
				newValue[key] !== activo[key]
			);
			setHasChanges(hasChanges);
			return newValue;
		});
	};
	// 1. PRIMERO: Cargar los hoteles del usuario desde sessionStorage
	useEffect(() => {
		// Obtener hoteles del usuario desde sessionStorage
		const userData = sessionStorage.getItem('user');
		if (userData) {
			try {
				const user = JSON.parse(userData);
				// Obtener los hoteles como string y dividirlos por coma
				const hotelString = user.Hoteles || '';
				const hotelCodes = hotelString.split(',').map((code: string) => code.trim()).filter((code: string) => code !== '');
				setUserHotels(hotelCodes);
			} catch (error) {
				console.error('Error parsing user data:', error);
				setUserHotels([]); // Asegurar que siempre sea un array
			}
		} else {
			setUserHotels([]); // Asegurar que siempre sea un array
		}
	}, []);

	// 2. Función para verificar permisos (debe estar definida antes de usarse)
	const checkPermission = (activoHotel: string, userHotelCodes: string[]) => {
		// Convertir el nombre del hotel del activo a minúsculas para comparación sin distinción de mayúsculas/minúsculas
		const activoHotelLower = activoHotel.toLowerCase();

		// Verificar si alguno de los códigos de hotel del usuario coincide con el hotel del activo
		return userHotelCodes.some(code => {
			const fullHotelName = hotelMappings[code];
			if (!fullHotelName) return false;

			// Comparar sin distinción de mayúsculas/minúsculas
			return fullHotelName.toLowerCase() === activoHotelLower;
		});
	};

	// 3. SEGUNDO: Cargar datos del activo (depende de userHotels)
	useEffect(() => {
		const fetchData = async () => {
			// No cargar datos hasta que userHotels esté disponible
			if (!id || userHotels.length === 0) return;

			setLoading(true);

			try {
				const [activoData, hotelesData, departamentosData, proveedoresData, modelosData, familiasData, estadosData, qrsApiData, imagenesData, facturasData, tiposAdquisicionData, arrendadorasData] = await Promise.all([
					activosApi.detalle(id),
					hotelesApi.listado(),
					departamentosApi.listado(),
					proveedoresApi.listado(),
					modelosApi.listado(),
					familiasApi.listado(),
					estadosApi.listado(),
					qrsApi.listado(),
					imagenesApi.listado(),
					facturasApi.listado(),
					tipoAdquisicionApi.listado(),
					arrendadorasApi.listado()
				]);

				if (activoData) {
					// Convertir PermitidoSalir de número a booleano para el frontend
					const activoConBooleanos = {
						...activoData,
						PermitidoSalir: activoData.PermitidoSalir === 1
					};

					setActivo(activoConBooleanos);
					setEditedActivo(activoConBooleanos);
				}

				if (!activoData) {
					toast({
						title: 'Error',
						description: 'No se pudo cargar la información del activo',
						status: 'error',
						duration: 5000,
						isClosable: true,
					});
					setLoading(false);
					setHasPermission(false); // ← Añadir esto
					return;
				}

				// Validar permisos - el usuario debe tener el hotel del activo
				const userHasPermission = checkPermission(activoData.Hotel, userHotels);
				setHasPermission(userHasPermission);

				if (!userHasPermission) {
					setLoading(false);
					return;
				}

				setActivo(activoData);
				setEditedActivo(activoData);
				setHoteles(hotelesData);
				setDepartamentos(departamentosData);
				setProveedores(proveedoresData);
				setModelos(modelosData);
				setSublineas(familiasData);
				setEstados(estadosData);
				setQR(qrsApiData);
				setImagenes(imagenesData);
				setFacturas(Array.isArray(facturasData) ? facturasData : []);
				setTiposAdquisicion(Array.isArray(tiposAdquisicionData) ? tiposAdquisicionData : []);
				setArrendadoras(Array.isArray(arrendadorasData) ? arrendadorasData : []);
			} catch (error) {
				toast({
					title: 'Error',
					description: 'Error al cargar la información',
					status: 'error',
					duration: 5000,
					isClosable: true,
				});
				setHasPermission(false); // ← Añadir esto
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [id, toast, userHotels]);

	// 4. TERCERO: Cargar historial (solo si tenemos permiso y id)
	useEffect(() => {
		const fetchHistorial = async () => {
			if (!id || !hasPermission) return;

			try {
				const historialData = await historialApi.listadoPorId(id);
				// Filtrar el historial para mostrar solo los del activo actual
				const historialFiltrado = historialData.filter((item: { ActivoId: any; }) => String(item.ActivoId) === String(id));
				setHistorial(historialData);
			} catch (error) {
				console.error('Error al cargar historial:', error);
			}
		};

		fetchHistorial();
	}, [id, hasPermission]); // Agregar hasPermission a las dependencias

	// 5. CUARTO: Actualizar modo de edición
	useEffect(() => {
		// Si el modo cambia en la URL, actualizar el estado de edición
		setIsEditing(mode === 'edit');
	}, [mode]);

	// 6. Modificar la condición de loading para incluir la carga de userHotels
	if (loading || userHotels.length === 0 || !hasPermission === null) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minH="400px">
				<Spinner size="xl" />
				<Text ml={4}>Cargando detalles del activo...</Text>
			</Box>
		);
	}
	const handleEdit = () => {
		setEditedActivo(activo);
		setIsEditing(true);
	};

	const handleCancel = () => {
		setEditedActivo(activo);
		setIsEditing(false);
		//enviamos a la lista de todos los activos 
		navigate('/admin/main/ecommerce/order-list');
	};

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
  const { id, value } = e.target;

  // Verificar si el cambio es en el estado y si se está cambiando a "Activo"
  if (id === 'EstadosId' && value === '1' && activo.UsuarioDueno !== 'no asignado') {
    onOpen();
  }

  setEditedActivo((prev: any) => {
    const newValue = {
      ...prev,
      [id]: value
    };
    
    // Verificar si hay cambios comparando con el activo original
    const hasChanges = Object.keys(newValue).some(key => {
      // Manejo especial para PermitidoSalir
      if (key === 'PermitidoSalir') {
        const normalize = (val: any) => {
          if (val === "Si" || val === 1 || val === true || val === "1") return "Si";
          return "No";
        };
        return normalize(newValue[key]) !== normalize(activo[key]);
      }
      
      return newValue[key] !== activo[key];
    });
    
    setHasChanges(hasChanges);
    return newValue;
  });
};

	const handleCreateArrendadora = async (nombre: string) => {
		const nombreLimpio = nombre.trim();
		if (!nombreLimpio) return;

		setIsCreatingArrendadora(true);
		try {
			const nueva = await arrendadorasApi.crear(nombreLimpio);
			setArrendadoras(prev => [...prev, nueva]);
			setEditedActivo((prev: any) => ({ ...prev, ArrendadoraId: nueva.Id.toString() }));
			toast({
				title: 'Arrendadora creada',
				description: `"${nueva.Name}" se agregó al catálogo de arrendadoras.`,
				status: 'success',
				duration: 4000,
				isClosable: true,
			});
		} catch (error: any) {
			const mensaje = error?.response?.data?.error || 'No se pudo crear la arrendadora.';
			toast({
				title: 'Error al crear arrendadora',
				description: mensaje,
				status: 'error',
				duration: 5000,
				isClosable: true,
			});
		} finally {
			setIsCreatingArrendadora(false);
		}
	};

	const handleNumericInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { id, value } = e.target;

		// Permitir solo números, punto decimal y vacío
		const numericValue = value.replace(/[^0-9.]/g, '');

		// Validar que no haya más de un punto decimal
		const decimalCount = (numericValue.match(/\./g) || []).length;
		const finalValue = decimalCount > 1 ? numericValue.replace(/\.+$/, '') : numericValue;

		setEditedActivo((prev: any) => ({
			...prev,
			[id]: finalValue
		}));

		// Verificar cambios
		const hasChanges = Object.keys({ ...activo, [id]: finalValue }).some(key =>
			key === id ? finalValue !== activo[key] : editedActivo[key] !== activo[key]
		);
		setHasChanges(hasChanges);
	};

	const canEditFields = () => {
		// Obtener el ID del estado actual (puede venir de editedActivo o activo)
		const estadoId = editedActivo.EstadosId || activo.EstadosId;
		const estadoNombre = editedActivo.Estado || activo.Estado;

		// Convertir a string para comparación consistente
		const estadoIdStr = String(estadoId);

		// Si el ID es 1 o el nombre es "Activo", permitir edición
		return estadoIdStr === '1' || estadoNombre === 'Activo';
	};
	const handleSave = async () => {
		const modifiedFields = Object.keys(editedActivo).filter(key =>
			editedActivo[key] !== activo[key]
		);

		console.log('modifiedFields:', modifiedFields);
		console.log('editedActivo.PermitidoSalir:', editedActivo.PermitidoSalir);
		console.log('activo.PermitidoSalir:', activo.PermitidoSalir);

		if (modifiedFields.length === 0) {
			toast({
				title: 'Sin cambios',
				description: 'No se han realizado cambios para guardar',
				status: 'info',
				duration: 3000,
				isClosable: true,
			});
			return;
		}

		// En handleSave(), dentro del map de modifiedFields:
		const updatedFields = modifiedFields.reduce((acc, key) => {
			let value = editedActivo[key];

			// Si el campo es 'PermitidoSalir', convertirlo a bit (1/0) para la BD
			if (key === 'PermitidoSalir') {
				// Convierte "Si"/"No" o true/false a 1/0
				if (value === "Si" || value === true) {
					value = 1;
				} else if (value === "No" || value === false) {
					value = 0;
				}
				// Si ya es 1 o 0, déjalo como está
			}

			// Si el campo es 'Activo', lo cambiamos a 'ActiveName'
			if (key === 'Activo') {
				return {
					...acc,
					['ActiveName']: value
				};
			}

			return {
				...acc,
				[key]: value
			};
		}, {});

		try {
			console.log('updatedFields (mapeado)', updatedFields);
			console.log('id', id);

			// Guarda los cambios en la API
			const response = await activosApi.editar(id, updatedFields);
			console.log('response', response);
			if (response) {
				toast({
					title: 'Éxito',
					description: 'Activo actualizado correctamente',
					status: 'success',
					duration: 5000,
					isClosable: true,
				});

				// También actualizamos el estado local mapeando ActiveName -> Activo si es necesario
				const updatedLocalFields = modifiedFields.reduce((acc, key) => ({
					...acc,
					[key]: editedActivo[key]
				}), {});

				setActivo({ ...activo, ...updatedLocalFields });
				setIsEditing(false);
				setHasChanges(false);
			} else {
				toast({
					title: 'Error',
					description: 'No se pudo actualizar el activo',
					status: 'error',
					duration: 5000,
					isClosable: true,
				});
			}
		} catch (error) {
			console.error('Error al guardar:', error);
			toast({
				title: 'Error',
				description: 'Error al actualizar el activo',
				status: 'error',
				duration: 5000,
				isClosable: true,
			});
		}
	};

	const handleUnassign = () => {
		// Lógica para desasignar el activo
		// Esto podría incluir cambiar el estado a "Activo" y limpiar el usuario asignado
		setEditedActivo((prev: any) => ({
			...prev,
			EstadosId: '1', // ID para estado "Activo"
			UsuariosId: null // Limpiar usuario asignado
		}));
		setHasChanges(true);
		onOpen(); // Mostrar advertencia
	};

	const crearEstadoHistorico = async (data: Record<string, any>) => {
		try {
			const response = await fetch('https://inventariosbackend.velasresorts.com/inventarios/estadoshistoricos/crear', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			});
			if (!response.ok) {
				throw new Error('Error al crear estado histórico');
			}
		} catch (error) {
			console.error('Error:', error);
		}
	};

	if (loading) {
		return (
			<Box display="flex" justifyContent="center" alignItems="center" minH="400px">
				<Spinner size="xl" />
				<Text ml={4}>Cargando detalles del activo...</Text>
			</Box>
		);
	}
	if (!hasPermission) {
		return (
			<Box pt={{ base: '160px', md: '140px', xl: '140px' }}>
				<Card
					bg={cardBg}
					borderRadius="lg"
					boxShadow="md"
					p={8}
					maxW="md"
					minH="250px"
					mx="auto"
				>
					<Center flexDirection="column" textAlign="center" h="100%">
						<Icon
							as={MdSecurity}
							w="50px"
							h="50px"
							color="red.400"
							mb={4}
						/>

						<Text
							fontSize="xl"
							fontWeight="semibold"
							color="red.500"
							mb={3}
						>
							Acceso denegado
						</Text>

						<Text
							fontSize="sm"
							color={textColorSecondary}
							mb={6}
						>
							No tienes permisos para ver este activo.
						</Text>

						<Button
							onClick={() => navigate('/admin/main/ecommerce/order-list')}
							colorScheme="blue"
							variant="outline"
							size="md"
							leftIcon={<Icon as={MdArrowBack} />}
						>
							Volver
						</Button>
					</Center>
				</Card>
			</Box>
		);
	}



	if (!activo) {
		return (
			<Box p={4}>
				<Text>No se encontró información del activo</Text>
			</Box>
		);
	}

	return (
		<Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
			<Card bg={cardBg} borderRadius='xl' boxShadow='xl'>

				{/* Botones (Acciones) */}
				<CardHeader>
					<Flex justify="flex-end" align="center">
						{isEditing ? (
							<>
								{/* {activo.Estado === 'assigned' && (
									<Button
										ml="10px"
										onClick={handleUnassign}
										colorScheme="red">
										Desasignar
									</Button>
								)} */}
								<Button
									ml="10px"
									onClick={handleCancel}
									colorScheme="gray">
									<Icon as={MdCancel} w='16px' h='16px' mr='5px' /> Cancelar
								</Button>

								<Button
									ml="10px"
									onClick={handleSave}
									isDisabled={!hasChanges}
									opacity={hasChanges ? 1 : 0.7}
									colorScheme="gray">
									<Icon as={MdSave} w='16px' h='16px' mr='5px' />
									{hasChanges ? 'Guardar Cambios' : 'Sin Cambios'}
								</Button>
							</>
						) : (
							<>

								{!isSoloLectura() && (
									<Button
										ml="10px"
										onClick={handleEdit}
										colorScheme="gray">
										<Icon as={MdEdit} w='16px' h='16px' mr='5px' /> Editar
									</Button>
								)}
								<Button
									ml="10px"
									onClick={() => navigate('/admin/main/ecommerce/order-list')}
									colorScheme="gray">
									<Icon as={MdArrowBack} w='16px' h='16px' mr='5px' /> Volver al Listado
								</Button>
							</>
						)}
					</Flex>
				</CardHeader>
				<HStack spacing={6} justify="center" align="start" mt={4} mb={4} px={4}>
					{/* Imagen del Código QR */}
					{qr.length > 0 && (() => {
						const qrFiltrado = qr.find(q => String(q.ActivoId) === String(id));
						return qrFiltrado?.Metadata?.data ? (
							<Box textAlign="center" p={4} bg={sectionBg} borderRadius="lg" border="1px solid" borderColor={borderColor}>
								<Heading size="sm" mb={2} color={textColor}>
									Código QR
								</Heading>
								<img
									src={bufferToString(qrFiltrado.Metadata.data)}
									alt="Código QR"
									style={{ maxWidth: '200px', height: 'auto' }}
								/>
							</Box>
						) : null;
					})()}

					{/* Imagen asociada al activo */}
					<Box textAlign="center" p={4} bg={sectionBg} borderRadius="lg" border="1px solid" borderColor={borderColor}>
  <Heading size="sm" mb={2} color={textColor}>
    Imagen del Activo
  </Heading>

  {(() => {
    const imagenFiltrada = imagenes.find(img => String(img.ActivosId) === String(id));
    const tieneImagen = !!imagenFiltrada;
    const imageUrl = imagePreview || imagenFiltrada?.URL_Imagen;

    return (
      <VStack spacing={3}>
        {/* Mostrar imagen o placeholder */}
        <Box
          width="250px"
          height="150px"
          border={!tieneImagen && !imagePreview ? "2px dashed" : "none"}
          borderColor={borderColor}
          borderRadius="8px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          overflow="hidden"
          cursor={imageUrl ? "pointer" : "default"}
          onClick={() => {
            if (imageUrl) {
              onOpenImageModal();
            }
          }}
          _hover={imageUrl ? {
            transform: "scale(1.02)",
            transition: "transform 0.2s",
            boxShadow: "md"
          } : {}}
        >
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={`Imagen de ${activo.Activo}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '8px'
              }}
            />
          ) : (
            <Text color={textColorSecondary} fontSize="sm">
              Sin imagen
            </Text>
          )}
        </Box>

        {/* Modal para imagen ampliada */}
        <Modal isOpen={isImageModalOpen} onClose={onCloseImageModal} size="xl" isCentered>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Imagen del Activo</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Center>
                <Image
                  src={imageUrl}
                  alt={`Imagen ampliada de ${activo.Activo}`}
                  maxW="100%"
                  maxH="70vh"
                  objectFit="contain"
                  borderRadius="md"
                />
              </Center>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="blue" mr={3} onClick={onCloseImageModal}>
                Cerrar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Botones de edición de imagen (solo en modo edición) */}
        {isEditing && (
          <>
            {isEditingImage ? (
              <VStack spacing={2} width="100%">
                <Input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setSelectedImage(file);
                      setImagePreview(URL.createObjectURL(file));
                    }
                  }}
                  size="sm"
                />
                <HStack spacing={2}>
                  <Button
                    size="sm"
                    colorScheme="blue"
                    onClick={async () => {
                      if (selectedImage) {
                        try {
                          const imagenExistente = imagenes.find(img => String(img.ActivosId) === String(id));

                          const customFormData = new FormData();
                          customFormData.append('imagen', selectedImage);

                          const metadata = {
                            activoId: id,
                            esEdicion: !!imagenExistente,
                            imagenId: imagenExistente?.Id || null
                          };

                          customFormData.append('metadata', JSON.stringify(metadata));

                          const uploadRes = await fetch(`https://inventariosbackend.velasresorts.com/inventarios/imagenes/editar/${metadata.activoId}`, {
                            method: 'POST',
                            body: customFormData,
                          });

                          if (!uploadRes.ok) {
                            const errorText = await uploadRes.text();
                            throw new Error(`Error: ${uploadRes.status} - ${errorText}`);
                          }

                          toast({
                            title: 'Éxito',
                            description: imagenExistente ? 'Imagen actualizada correctamente' : 'Imagen agregada correctamente',
                            status: 'success',
                            duration: 3000,
                            isClosable: true,
                          });

                          setIsEditingImage(false);
                          setSelectedImage(null);
                          setImagePreview(null);

                          setTimeout(async () => {
                            const imagenesData = await imagenesApi.listado();
                            setImagenes(imagenesData);
                          }, 1000);

                        } catch (error) {
                          console.error('Error:', error);
                          toast({
                            title: 'Error',
                            status: 'error',
                            duration: 3000,
                            isClosable: true,
                          });
                        }
                      }
                    }}
                    loadingText="Subiendo..."
                  >
                    {tieneImagen ? 'Actualizar Imagen' : 'Agregar Imagen'}
                  </Button>
                  <Button
                    size="sm"
                    variant="outline"
                    onClick={() => {
                      setIsEditingImage(false);
                      setSelectedImage(null);
                      setImagePreview(null);
                    }}
                  >
                    Cancelar
                  </Button>
                </HStack>
              </VStack>
            ) : (
              // Solo renderiza el botón si el estado es "activo"
              (activo.Estado === "active" || activo.Estado === "bodega") && (

                <Button
                  size="sm"
                  colorScheme={tieneImagen ? "gray" : "blue"}
                  onClick={() => setIsEditingImage(true)}
                  leftIcon={<Icon as={MdEdit} />}
                >
                  {tieneImagen ? 'Cambiar Imagen' : 'Agregar Imagen'}
                </Button>
              )

            )}
          </>
        )}

      </VStack>
    );
  })()}
</Box>
				</HStack>

				{/* Encabezado: nombre, folio y estados clave del activo */}
				<Box textAlign="center" px={4} py={4} borderBottom="1px" borderColor={borderColor}>
					<Heading size="md" color={textColor} mb={1}>
						{activo.Activo}
					</Heading>

					<HStack justify="center" spacing={1.5} mb={3}>
						<Icon as={MdQrCode2} color={textColorSecondary} w={3.5} h={3.5} />
						<Text
							fontSize="xs"
							fontWeight="bold"
							fontFamily="mono"
							color="white"
							bg="blue.500"
							display="inline-block"
							px={2.5}
							py={0.5}
							borderRadius="6px"
						>
							{activo.Folio}
						</Text>
					</HStack>

					<Wrap justify="center" spacing={2}>
						<WrapItem>
							<Badge
								colorScheme={activo.PermitidoSalir === "Si" && activo.UsuarioDueno !== "no asignado" ? "green" : "red"}
								fontSize="xs" px={2} py={0.5} borderRadius="6px"
							>
								{activo.PermitidoSalir === "Si" && activo.UsuarioDueno !== "no asignado" ? "Puede salir" : "No puede salir"}
							</Badge>
						</WrapItem>
						<WrapItem>
							<Badge colorScheme="blue" fontSize="xs" px={2} py={0.5} borderRadius="6px">
								{activo.Estado}
							</Badge>
						</WrapItem>
						{activo.TipoAdquisicion && (
							<WrapItem>
								<Badge
									colorScheme={
										activo.TipoAdquisicion === 'Capex' ? 'blue' :
										activo.TipoAdquisicion === 'OPEX' ? 'orange' : 'purple'
									}
									fontSize="xs" px={2} py={0.5} borderRadius="6px"
								>
									{activo.TipoAdquisicion}
								</Badge>
							</WrapItem>
						)}
						{activo.RubroDepreciacion && (
							<WrapItem>
								<Badge colorScheme="gray" fontSize="xs" px={2} py={0.5} borderRadius="6px">
									${Number(activo.DepreciacionMensual || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}/mes
								</Badge>
							</WrapItem>
						)}
					</Wrap>

					{activo.UsuarioDueno === "no asignado" && (
						<Text fontSize="xs" color={textColorSecondary} mt={2}>
							El activo no está asignado a ningún usuario
						</Text>
					)}
				</Box>


				{/* Contenido Principal */}
				<CardBody>
					<SimpleGrid columns={{ base: 1, md: 2 }} spacing={8}>

						<Stack spacing={6}>
							{/* Información Principal */}
							<Box p={4} bg={sectionBg} borderRadius="lg">
								<Heading size="sm" mb={4} color={textColor}>
									Información Principal
								</Heading>
								<Stack spacing={4}>

									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdAttachMoney} mr={2} />
											Nombre del activo
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<InputField
												id="Activo"  // Se mantiene "Activo" en el frontend
												value={editedActivo.Activo}  // Se mantiene "Activo" en el frontend
												onChange={handleInputChange}
												type="text"
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.Activo}  {/* Quitado el $ y se mantiene "Activo" */}
											</StatNumber>
										)}
									</Stat>

									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdAttachMoney} mr={2} />
											Precio
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<InputField
												id="Precio"
												value={editedActivo.Precio}
												onChange={handleNumericInputChange}
												type="text"
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												${activo.Precio}
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdAttachMoney} mr={2} />
											Precio depreciado
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<InputField
												id="Precio_depreciado"
												value={editedActivo.Precio_depreciado}
												onChange={handleNumericInputChange}
												type="text"
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												${activo.Precio_depreciado}
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdCalendarToday} mr={2} />
											Fecha de adquisición
										</StatLabel>
										{isEditing ? (
											<InputField
												type="date"
												id="FechaAdquisicion"
												value={editedActivo.FechaAdquisicion ? editedActivo.FechaAdquisicion.split('T')[0] : ''}
												onChange={handleInputChange}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.FechaAdquisicion ? new Date(activo.FechaAdquisicion).toLocaleDateString('es-MX') : 'No especificada'}
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdSecurity} mr={2} />
											Número de Serie
										</StatLabel>
										{isEditing ? (
											<InputField
												id="SerialNumber"
												value={editedActivo.SerialNumber}
												onChange={handleInputChange}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">{activo.SerialNumber}</StatNumber>
										)}
									</Stat>

									<Stat>
    <StatLabel fontSize="md">
        <Icon as={MdSecurity} mr={2} />
        Fecha de Garantía
    </StatLabel>
    {isEditing ? (
        <InputField
            type="date"
            id="Garantia"
            value={editedActivo?.Garantia ? editedActivo.Garantia.split('T')[0] : ''}
            onChange={handleInputChange}
            isDisabled={!canEditFields()}
        />
    ) : (
        <StatNumber color={textColorSecondary} fontSize="sm">
            {activo.Garantia ? new Date(activo.Garantia).toLocaleDateString() : 'Sin garantía'}
        </StatNumber>
    )}
</Stat>
								</Stack>
							</Box>
							{/*Ubicación*/}
							<Box p={4} bg={sectionBg} borderRadius="lg">
								<Heading size="sm" mb={4} color={textColor}>
									Ubicación
								</Heading>
								<Stack spacing={4}>
									{/* Campos existentes de Hotel y Departamento */}
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdHotel} mr={2} />
											Hotel
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<PickList
												id="HotelId"
												value={null}
												placeholder="Campo en desarrollo. Contacte al equipo de desarrollo."
												options={[]}
												isDisabled={true}
												onChange={() => { }}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.Hotel}
											</StatNumber>
										)}
									</Stat>


									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdLocationOn} mr={2} />
											Departamento
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<PickList
												id="DepartamentoId"
												value={editedActivo.DepartamentoId}
												placeholder={activo.Departamento}
												onChange={handleInputChange}
												options={(() => {
													const permitidos = getDepartamentosPermitidos();
													return permitidos === null
														? departamentos
														: departamentos.filter(d => permitidos.includes(Number(d.Id)));
												})().map(departamento => ({
													value: departamento.Id,
													label: departamento.Name
												}))}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.Departamento}
											</StatNumber>
										)}
									</Stat>

									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdLocationOn} mr={2} />
											Ubicación exacta
										</StatLabel>
										{isEditing ? (
											<InputField
												id="UbicacionExacta"
												value={editedActivo.UbicacionExacta || ''}
												placeholder="Ej. Piso 3, habitación 305, closet de TV"
												onChange={handleInputChange}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.UbicacionExacta || 'No especificada'}
											</StatNumber>
										)}
									</Stat>

									{/* Nuevo: Mapa de Google embebido */}
									<Box mt={4}>
										<Text fontSize="md" mb={2} display="flex" alignItems="center">
											<Icon as={MdLocationOn} mr={2} />
											Ubicación en mapa
										</Text>

										{(() => {
											const mapasHoteles = {
												'Grand Velas Riviera Nayarit': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.070975484287!2d-105.30360862621987!3d20.707342280862733!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842146b9ce435737%3A0xc16ec8df0575b94d!2sGrand%20Velas%20Riviera%20Nayarit!5e0!3m2!1ses!2smx!4v1753909914664!5m2!1ses!2smx',
												'Grand Velas Riviera Maya': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.874953230306!2d-87.02571932622105!3d20.674665780887523!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8f4e5d781aae6d93%3A0xd9906e1324d837f9!2sGrand%20Velas%20Riviera%20Maya!5e0!3m2!1ses!2smx!4v1753910073938!5m2!1ses!2smx',
												'Grand Velas Los Cabos': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.5066627300343!2d-109.79475952481344!3d22.968389079211715!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4e70f5fdae39%3A0xdd31fe13668ab9ac!2sGrand%20Velas%20Los%20Cabos!5e0!3m2!1ses-419!2smx!4v1755112504304!5m2!1ses-419!2smx',
												'Velas Vallarta': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.103790788463!2d-105.262192824881!3d20.66535598089455!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842145b9ecabf2cb%3A0xf31d2736d204cac8!2sVelas%20Vallarta!5e0!3m2!1ses-419!2smx!4v1755112544374!5m2!1ses-419!2smx',
												'Casa Velas': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3733.065518771477!2d-105.25902632488102!3d20.6669132808934!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842145b9ecabf2cb%3A0xdb0192c75f9d41ba!2sCasa%20Velas!5e0!3m2!1ses-419!2smx!4v1755112614872!5m2!1ses-419!2smx',
												'Mar del Cabo': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4892688232203!2d-109.79365512481344!3d22.96902917921127!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86af4fc1b3f2eed7%3A0x3846ae134155127b!2sMar%20Del%20Cabo%20by%20VELAS%20RESORTS!5e0!3m2!1ses-419!2smx!4v1755112649477!5m2!1ses-419!2smx',
												'Grand Velas Boutique Los Cabos': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3673.4874943526493!2d-109.79318612481347!3d22.96909447921126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x81345facfdab2293%3A0x25b7637ce09b2319!2sGrand%20Velas%20Boutique%20Los%20Cabos!5e0!3m2!1ses-419!2smx!4v1755112680035!5m2!1ses-419!2smx'
											};

											const urlMapa = mapasHoteles[activo.Hotel as keyof typeof mapasHoteles];


											return urlMapa ? (
												<iframe
													width="100%"
													height="180"
													style={{ border: 0, borderRadius: '8px' }}
													loading="lazy"
													allowFullScreen
													src={urlMapa}
												/>
											) : null;
										})()}
									</Box>


								</Stack>
							</Box>
						</Stack>
						{/* Columna */}
						<Stack spacing={6}>
							{/* Clasificación */}
							<Box p={4} bg={sectionBg} borderRadius="lg">
								<Heading size="sm" mb={4} color={textColor}>
									Clasificación
								</Heading>
								<Stack spacing={4}>
									{/* <Stat>
										<StatLabel fontSize="md">
											<Icon
												as={MdCategory}
												mr={2} />
											Subfamilia
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										<br />
										{isEditing ? (
											<PickList
												id="SublineaId"  // Cambia SubfamiliaId por SublineaId si ese es el nombre en tu modelo
												position="relative"
												bottom="10px"
												value={editedActivo.SublineaId} // Asegúrate que coincida con tu modelo
												placeholder={activo.Sublinea} // Usa el campo correcto
												onChange={handleInputChange}
												options={sublineas.map(sublinea => ({
													value: sublinea.Id, // O sublinea.id_sub si ese es el nombre real
													label: sublinea.Name
												}))}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber
												color={textColorSecondary}
												fontSize="sm"
												mb="10px"
											>
												{activo.Sublinea}
											</StatNumber>
										)}
									</Stat> */}
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdComputer} mr={2} />
											Modelo
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<SelectField
												id="ModeloId"
												value={editedActivo.ModeloId?.toString()}
												placeholder={activo.Modelo}
												onChange={(value: string) =>
													handleInputChange({ target: { id: 'ModeloId', value } } as any)
												}
												options={modelos.map(modelo => ({
													value: modelo.Id.toString(),
													label: modelo.Name
												}))}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.Modelo}
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdBusiness} mr={2} />
											Proveedor
											<Text as="span" color="red.500" ml="2">
												*
											</Text>
										</StatLabel>
										{isEditing ? (
											<SelectField
												id="ProveedorId"
												value={editedActivo.ProveedorId?.toString()}
												placeholder={activo.Proveedor}
												onChange={(value: string) =>
													handleInputChange({ target: { id: 'ProveedorId', value } } as any)
												}
												options={proveedores.map(proveedor => ({
													value: proveedor.Id.toString(),
													label: proveedor.Proveedor
												}))}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.Proveedor}
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdDescription} mr={2} />
											Factura
										</StatLabel>
										{isEditing ? (
											<SelectField
												id="FacturaId"
												value={editedActivo.FacturaId?.toString()}
												placeholder={activo?.FacturaFolio || 'Sin factura relacionada'}
												onChange={(value: string) =>
													handleInputChange({ target: { id: 'FacturaId', value } } as any)
												}
												options={facturas.map((factura: any) => ({
													value: factura.Id.toString(),
													label: factura.Folio
												}))}
												isDisabled={!canEditFields()}
											/>
										) : (
											<Box>
												<StatNumber color={textColorSecondary} fontSize="sm" mb="6px">
													{activo?.FacturaFolio || 'Sin factura relacionada'}
												</StatNumber>
												{activo?.FacturaId && (
													<HStack spacing={2}>
														<Button
															size="xs"
															variant="outline"
															leftIcon={<Icon as={MdAttachMoney} />}
															onClick={() => window.open(facturasApi.descargarPdfUrl(activo.FacturaId), '_blank')}
														>
															Descargar factura
														</Button>
														<Button
															size="xs"
															variant="outline"
															leftIcon={<Icon as={MdDescription} />}
															onClick={() => window.open(facturasApi.descargarDetalleUrl(activo.FacturaId), '_blank')}
														>
															Descargar detalle
														</Button>
													</HStack>
												)}
											</Box>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdCategory} mr={2} />
											Tipo de adquisición
										</StatLabel>
										{isEditing ? (
											<Box mt={1}>
												<SelectField
													id="TipoAdquisicionId"
													value={editedActivo.TipoAdquisicionId?.toString()}
													placeholder={activo.TipoAdquisicion || 'Selecciona un tipo'}
													onChange={(value: string) => {
														const tipoElegido = tiposAdquisicion.find(t => t.Id.toString() === value);
														const esArrendamiento = tipoElegido?.Name?.toLowerCase() === 'arrendamiento';
														setEditedActivo((prev: any) => ({
															...prev,
															TipoAdquisicionId: value,
															...(esArrendamiento ? {} : { ArrendadoraId: '' }),
														}));
														setHasChanges(true);
													}}
													options={tiposAdquisicion.map(tipo => ({
														value: tipo.Id.toString(),
														label: tipo.Name
													}))}
													isDisabled={!canEditFields()}
												/>
												{!canEditFields() && (
													<Text fontSize="xs" color={textColorSecondary} mt={1}>
														No se puede cambiar mientras el activo esté asignado.
													</Text>
												)}
											</Box>
										) : (
											<Box mt={1}>
												{activo?.TipoAdquisicion ? (
													<Badge
														colorScheme={
															activo.TipoAdquisicion === 'Capex' ? 'blue' :
															activo.TipoAdquisicion === 'OPEX' ? 'orange' :
															'purple'
														}
														fontSize="xs" px={2} py={1} borderRadius="6px"
													>
														{activo.TipoAdquisicion}
													</Badge>
												) : (
													<Badge colorScheme="gray" fontSize="xs" px={2} py={1} borderRadius="6px">
														Sin clasificar
													</Badge>
												)}
											</Box>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdAttachMoney} mr={2} />
											Depreciación mensual
										</StatLabel>
										<Box mt={1}>
											{activo?.RubroDepreciacion ? (
												<>
													<StatNumber fontSize="md">
														${Number(activo.DepreciacionMensual || 0).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
													</StatNumber>
													<StatNumber color={textColorSecondary} fontSize="sm" mt={1}>
														{activo.RubroDepreciacion} · {activo.PorcentajeDepreciacion}% anual
													</StatNumber>
												</>
											) : (
												<Badge colorScheme="gray" fontSize="xs" px={2} py={1} borderRadius="6px">
													Sin rubro asignado
												</Badge>
											)}
										</Box>
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdCalendarToday} mr={2} color="red.500" />
											Depreciación acumulada
										</StatLabel>
										<Box mt={1}>
											{activo?.ValorEnLibros !== null && activo?.ValorEnLibros !== undefined ? (
												<>
													<Text fontSize="xs" color={textColorSecondary} mb={1}>
														{activo.FechaAdquisicion
															? new Date(activo.FechaAdquisicion).toLocaleDateString('es-MX', { timeZone: 'UTC' })
															: '—'}
														{' → '}
														{new Date().toLocaleDateString('es-MX')}
														{' '}({activo.MesesTranscurridos} mes{activo.MesesTranscurridos !== 1 ? 'es' : ''})
													</Text>
													<Progress
														value={(activo.DepreciacionAcumulada / activo.Precio) * 100}
														size="sm"
														borderRadius="full"
														colorScheme="red"
														bg={progressTrackBg}
														mb={2}
													/>
													<Text fontSize="sm" fontWeight="700" color="red.500">
														-${Number(activo.DepreciacionAcumulada).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
														{' '}depreciados ({((activo.DepreciacionAcumulada / activo.Precio) * 100).toFixed(1)}%)
													</Text>
													<Text fontSize="xs" color={textColorSecondary} mt={1}>
														Costo original ${Number(activo.Precio).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
														{' — '}Valor en libros hoy{' '}
														<Text as="span" fontWeight="700" color={textColor}>
															${Number(activo.ValorEnLibros).toLocaleString('es-MX', { minimumFractionDigits: 2 })}
														</Text>
													</Text>
												</>
											) : (
												<Badge colorScheme="gray" fontSize="xs" px={2} py={1} borderRadius="6px">
													Falta Fecha de adquisición o Rubro de depreciación
												</Badge>
											)}
										</Box>
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdCarRental} mr={2} />
											Arrendamiento
										</StatLabel>
										{isEditing && (() => {
											const tipoElegido = tiposAdquisicion.find(t => t.Id.toString() === editedActivo.TipoAdquisicionId?.toString());
											return tipoElegido?.Name?.toLowerCase() === 'arrendamiento';
										})() ? (
											<Box mt={1}>
												<SelectField
													id="ArrendadoraId"
													placeholder="Selecciona o escribe para crear una arrendadora"
													isLoading={isCreatingArrendadora}
													creatable
													onCreateOption={handleCreateArrendadora}
													options={arrendadoras.map(arrendadora => ({
														value: arrendadora.Id.toString(),
														label: arrendadora.Name,
													}))}
													value={editedActivo.ArrendadoraId?.toString()}
													onChange={(value: string) => {
														setEditedActivo((prev: any) => ({ ...prev, ArrendadoraId: value }));
														setHasChanges(true);
													}}
													isDisabled={!canEditFields()}
												/>
											</Box>
										) : (
											<Box mt={1}>
												{activo?.ArrendadoraId ? (
													<>
														<Badge colorScheme="orange" fontSize="xs" px={2} py={1} borderRadius="6px">
															Arrendado
														</Badge>
														<StatNumber color={textColorSecondary} fontSize="sm" mt={1}>
															{activo?.Arrendadora || 'Arrendadora sin nombre'}
														</StatNumber>
													</>
												) : (
													<Badge colorScheme="gray" fontSize="xs" px={2} py={1} borderRadius="6px">
														Activo propio
													</Badge>
												)}
											</Box>
										)}
									</Stat>
								</Stack>
							</Box>
							{/* Asignación */}
							{/* PENDIENTE: Aqui van a cargarse los usuarios, Falta consumir API y tener un algoritmo para cambiar el estado a ASIGNADO */}
							<Box p={4} bg={sectionBg} borderRadius="lg">
								<Heading size="sm" mb={4} color={textColor}>
									Asignación
								</Heading>
								<Stack spacing={4}>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdPerson} mr={2} />
											Usuario
										</StatLabel>
										{isEditing ? (
											<PickList
												id="UsuariosId"
												value={editedActivo.UsuariosId}
												placeholder={activo.Usuario}
												onChange={handleInputChange}
												options={[]}
												isDisabled={!canEditFields()}
											/>
										) : (
											<StatNumber color={textColorSecondary} fontSize="sm">
												{activo.UsuarioDueno || 'No asignado'} - ({activo.NumControl != null ? activo.NumControl : 'Sin dato'})
											</StatNumber>
										)}
									</Stat>
									<Stat>
										<StatLabel fontSize="md">
											<Icon as={MdExitToApp} mr={2} />
											Permitido Salir
										</StatLabel>
										{isEditing ? (
											<FormControl display="flex" alignItems="center">
												<FormLabel htmlFor="PermitidoSalir" mb="0">
													{/* Muestra el texto basado en el valor actual */}
													{editedActivo?.PermitidoSalir ? "Puede salir" : "No puede salir"}
													{editedActivo?.UsuarioDueno === "no asignado" && " (Asigna dueño primero)"}
												</FormLabel>
												<Switch
													id="PermitidoSalir"
													// Convierte "Si"/"No" a true/false para el Switch
													isChecked={editedActivo?.PermitidoSalir === "Si" ||
														editedActivo?.PermitidoSalir === 1 ||
														editedActivo?.PermitidoSalir === true}
													onChange={(e) => {
														// Solo permitir cambiar si hay dueño asignado
														if (editedActivo?.UsuarioDueno === "no asignado") {
															return;
														}
														// Guarda como "Si" o "No"
														handleSwitchChange('PermitidoSalir', e.target.checked ? "Si" : "No");
													}}
													colorScheme={
														editedActivo?.UsuarioDueno === "no asignado"
															? "gray"
															: editedActivo?.PermitidoSalir === "Si"
																? "green"
																: "red"
													}
													isDisabled={editedActivo?.UsuarioDueno === "no asignado"}
												/>
											</FormControl>
										) : (
											<StatNumber
												color={activo.PermitidoSalir === "Si" && activo.UsuarioDueno !== "no asignado"
													? "green.500"
													: "red.500"}
												fontSize="sm"
											>
												{activo.PermitidoSalir === "Si" && activo.UsuarioDueno !== "no asignado"
													? "Sí puede salir"
													: "No puede salir"}
											</StatNumber>
										)}
									</Stat>

									{/* 					<Stat>
					  <StatLabel
						fontSize="md"
						position="relative"
						bottom="35px"
					  >
						<Icon as={MdCalendarToday} mr={2} />
						Último Login
					  </StatLabel>
					  {isEditing ? (
						<InputField
						  type="datetime-local"
						  id="LastLogin"
						  position="relative"
						  bottom="25px"
						  value={editedActivo.LastLogin}
						  placeholder={activo.LastLogin}
						  onChange={handleInputChange}
						/>
					  ) : (
						<StatNumber
						  color={textColorSecondary}
						  fontSize="sm"
						  mb="10px"
						  position="relative"
						  bottom="30px"
						>
						  {activo.LastLogin ? new Date(activo.LastLogin).toLocaleDateString() : 'N/A'}
						</StatNumber>
					  )}
					</Stat> */}
								</Stack>
							</Box>

							{!['assigned', 'pending', 'pending_baja', 'baja', 'pending_salida', 'fuera_propiedad'].includes(activo.Estado) && (
  <Box p={4} bg={sectionBg} borderRadius="lg">
    <Heading size="sm" mb={4} color={textColor}>
      Estado del Activo
    </Heading>
    <Stat>
      <StatLabel fontSize="md">
        <Icon as={MdSecurity} mr={2} />
        Estado actual: <Badge colorScheme="blue" ml={2}>{activo.Estado}</Badge>
      </StatLabel>
      {isEditing && (
        <Box mt={3}>
          <PickList
            id="EstadosId"
            value={editedActivo.EstadosId}
            placeholder="Seleccionar nuevo estado..."
            onChange={handleInputChange}
            options={estados
              .filter(e => e.Name === 'active' || e.Name === 'inactive' || e.Name === 'bodega' || e.Name === 'rma')
              .map(e => ({
                value: e.Id,
                label: e.Name === 'active' ? 'Activo' : e.Name === 'inactive' ? 'Inactivo' : e.Name === 'bodega' ? 'Bodega' : 'RMA'
              }))}
          />
        </Box>
      )}
    </Stat>
  </Box>
)}

							<Box p={4} bg={sectionBg} borderRadius="lg">
  <Stat>
    <StatLabel fontSize="md">
      <Icon as={MdDescription} mr={2} />
      Descripción
    </StatLabel>
    {isEditing ? (
      <Textarea
        id="Descripcion"
        value={editedActivo?.Descripcion || ''}
        onChange={(e) => handleInputChange(e)}
        placeholder="Ingresa una descripción"
        size="sm"
        isDisabled={!canEditFields()}
        minH="100px"
      />
    ) : (
      <StatNumber color={textColorSecondary} fontSize="sm">
        {activo.Descripcion || 'N/A'}
      </StatNumber>
    )}
  </Stat>
</Box>
						</Stack>

					</SimpleGrid>
				</CardBody>
			</Card>

			{/* Diálogo de confirmación para desasignar activo */}
			<AlertDialog
				isOpen={isOpen}
				leastDestructiveRef={cancelRef}
				onClose={onClose}
			>
				<AlertDialogOverlay>
					<AlertDialogContent>
						<AlertDialogHeader fontSize="lg" fontWeight="bold">
							Confirmar desasignación
						</AlertDialogHeader>

						<AlertDialogBody>
							Este activo será desasignado y se deberá crear un nuevo resguardo con él.
							¿Estás seguro que deseas continuar?
						</AlertDialogBody>

						<AlertDialogFooter>
							<Button ref={cancelRef} onClick={onClose}>
								Cancelar
							</Button>
							<Button
								colorScheme="red"
								onClick={async () => {
									onClose();
									await handleSave();

									// Crear el objeto a enviar
									const historico = {
										activoId: activo.Id,
										estado: 'activo', // o usa el ID numérico si se espera
										fechaCambio: new Date().toISOString(),
										nombrePersona: activo.UsuarioDueno || 'Desconocido',
										numControl: activo.NumControl || 'Sin dato',
									};

									await crearEstadoHistorico(historico);
								}}
								ml={3}
							>
								Confirmar
							</Button>

						</AlertDialogFooter>
					</AlertDialogContent>
				</AlertDialogOverlay>
			</AlertDialog>
			<Box mt={6}>
				<Card bg={cardBg} borderRadius="xl" boxShadow="md" p={6}>
					<Heading size="md" mb={4} color={textColor}>
						Historial de Estados
					</Heading>
					{historial.length === 0 ? (
						<Text color={textColorSecondary}>No hay historial disponible para este activo.</Text>
					) : (

						<Box overflowX="auto">

							<table style={{ width: '100%', borderCollapse: 'collapse' }}>
								<thead>
									<tr>
										<th style={{ padding: '8px', borderBottom: '1px solid #ccc', textAlign: 'left' }}>Fecha de Cambio</th>
										<th style={{ padding: '8px', borderBottom: '1px solid #ccc', textAlign: 'left' }}>Estado</th>
										<th style={{ padding: '8px', borderBottom: '1px solid #ccc', textAlign: 'left' }}>Responsable</th>
										<th style={{ padding: '8px', borderBottom: '1px solid #ccc', textAlign: 'left' }}>Número de Control</th>
									</tr>
								</thead>
								<tbody>
									{historial.map((item, index) => (
										<tr key={index}>
											<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
												{new Date(item.FechaCambio).toLocaleString()}
											</td>
											<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.estado}</td>
											<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.usuarioColab}</td>
											<td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{item.nombreColab}</td>
										</tr>
									))}
								</tbody>
							</table>
						</Box>
					)}
				</Card>
			</Box>

		</Box>
	)
};

export default ProductPage;